export enum StatusCodes {
  UnsupportedType = 415,
  SizeTooLarge = 413,
}
